/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import {
    string, node, object, bool,
} from 'prop-types';
import { useDispatch } from 'react-redux';
import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const LinkOrATag = ({
    href, id, children, style, name, className, key, dataTest, trackingEventLabel, isTrackEventEnabled,
}) => {
    const dispatch = useDispatch();
    const isExternalLink = href?.includes('/blog') || href?.includes('www') || href?.indexOf('http://') === 0 || href?.indexOf('https://') === 0;
    const handleTrackEvent = () => {
        if (isTrackEventEnabled && trackingEventLabel) {
            dispatch(trackEvent({
                eventCategory: isExternalLink ? 'external-link' : 'internal-link',
                eventAction: isExternalLink ? href : `https://www.1800flowers.com${href}`,
                eventLabel: trackingEventLabel || '',
            }));
        }
    };
    if (isExternalLink) {
        return <a tabIndex="-1" style={style} className={className} id={id} href={href} name={name} key={key} data-test={dataTest} onClick={handleTrackEvent}>{children}</a>;
    }
    return <Link tabIndex="-1" style={style} to={href} id={id} className={className} name={name} key={key} data-test={dataTest} onClick={handleTrackEvent}>{children}</Link>;
};

LinkOrATag.propTypes = {
    href: string.isRequired,
    id: string,
    children: node.isRequired,
    style: object,
    name: string,
    className: string,
    key: string,
    dataTest: string,
    trackingEventLabel: string,
    isTrackEventEnabled: bool,
};

LinkOrATag.defaultProps = {
    id: '',
    style: {},
    name: '',
    className: '',
    key: '',
    dataTest: '',
    trackingEventLabel: '',
    isTrackEventEnabled: false,
};

export default LinkOrATag;
